<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-5"><a href="#/Text/Covenant_with_Hell2#Contents-A">Acknowledgments</a></p>
<p class="fp">Christine and Peter Goodhugh, Henie Lentz, Dianne Levy, Sharon Kay Penman, Barbara Peters (Poisoned Pen Bookstore in Scottsdale AZ), Robert Rosenwald and all the staff of Poisoned Pen Press, Marianne and Sharon Silva, Lyn and Michael Speakman, the staff of the University Press Bookstore (Berkeley CA).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Covenant_with_Hell-4.vue?46f921ec